import { render, staticRenderFns } from "./shipping-carriers.vue?vue&type=template&id=3f2e8ea0&"
import script from "./shipping-carriers.vue?vue&type=script&lang=js&"
export * from "./shipping-carriers.vue?vue&type=script&lang=js&"
import style0 from "./shipping-carriers.vue?vue&type=style&index=0&id=3f2e8ea0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports